module.exports = __webpack_public_path__ + "static/img/竹山美閣.c59e5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/竹山美閣.png?20181011
// module id = G8eD
// module chunks = 1